module.exports = __webpack_public_path__ + "static/casual-fridays-3-1d13fd7350626d26f0d58b3e566d1307.jpg";